import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useSetAtom } from 'jotai';
import { useIntl } from 'react-intl';
import NoAccountsIcon from '@mui/icons-material/NoAccounts';
import { useNavigate } from 'react-router-dom';
import {
  userDataAtom,
  selectedBranchAtom,
  userBranchesAtom,
} from '../../Atoms';
import ContentError from '../../Components/Error/ContentError';
import '../../Styles/app.scss';

const NotAuthenticated = function NotAuthenticated({ noRedirect = false }) {
  const navigate = useNavigate();
  const intl = useIntl();
  const setUserData = useSetAtom(userDataAtom);
  const setSelectedBranch = useSetAtom(selectedBranchAtom);
  const setUserBranches = useSetAtom(userBranchesAtom);
  let timeoutRef = null;

  useEffect(() => {
    localStorage.removeItem('authorizationData');
  }, []);
  useEffect(() => {
    //noRedirect prop disables the auto redirect to login
    if (!noRedirect) timeoutRef = setTimeout(() => navigate('/'), 5000); // '/' is login page
  }, []);

  const handleGoHome = () => {
    if (!noRedirect) clearTimeout(timeoutRef);
    setUserData(null);
    setSelectedBranch(null);
    setUserBranches(null);
    navigate('/');
  };
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <ContentError
        icon={<NoAccountsIcon sx={{ color: '#acacac', fontSize: '64px' }} />}
        text={intl.messages.FAILED_AUTH}
        message={intl.messages.FAILED_AUTH_MESSAGE}
        sizes={{
          title: '56px',
          message: '24px',
        }}
      />
      <Button variant="outlined" onClick={handleGoHome}>
        {intl.messages.BACK_TO_LOGIN}
      </Button>
    </div>
  );
};
NotAuthenticated.propTypes = {
  noRedirect: PropTypes.bool,
};

export default NotAuthenticated;
